import "@theme/front/init.scss";
import "@/front/confirm.js";

import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";

import "nette.ajax.js";

import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";

import AutoComplete from "autocomplete-js";
import "autocomplete-js/dist/autocomplete.css";

import StarRating from "star-rating.js";
import "star-rating.js/dist/star-rating.css";

import Typed from "typed.js";

import "@/front/alert";
import "@/front/cart";
import "@/front/cookie";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	$.nette.init();

	$("[data-toggle='tooltip']").tooltip({
		container: "body",
		delay: {show: 500, hide: 100}
	});

	if (window.app.searchUrl && window.app.productPageUrl) {
		AutoComplete({
			Url: window.app.searchUrl,
			MinChars: 3,
			QueryArg: "product-search",
			_Render: function (response) {
				if (this.DOMResults.hasChildNodes()) {
					this.DOMResults.removeChild(this.DOMResults.childNodes[0]);
				}
				var ul = document.createElement("div");

				if (response === "") {
					var div = document.createElement("div");
					div.classList.add("bg-danger", "text-white", "dropdown-item", "text-center", "p-3");
					div.innerHTML = "Nic jsme bohužel nenašli, zkuste jiný výraz.";

					ul.appendChild(div);
				} else {
					const items = JSON.parse(response);

					for (var key in items) {
						if (!items.hasOwnProperty(key)) continue;

						var a = document.createElement("a");
						var item = items[key];

						a.classList.add("dropdown-item");
						a.href = window.app.productPageUrl + "/" + item.slug;
						a.title = item.name;

						if (item.image) {
							a.innerHTML = "<img src='/upload/product/" + item.id + "/" + item.image + "' />" + item.name;
						} else {
							a.innerHTML = item.name;
						}

						ul.appendChild(a);
					}

					a = document.createElement("a");

					a.classList.add("dropdown-item", "bg-secondary", "text-white", "px-3", "py-2", "form-search-toggle", "cursor-pointer");
					a.innerHTML = "<i class='mdi mdi-magnify mdi-scale-1-3'></i>&nbsp;&nbsp;Zobrazit všechny výsledky vyhledávání";

					ul.appendChild(a);
				}

				this.DOMResults.appendChild(ul);

				$(".form-search-toggle").off("click").on("click", function () {
					$(this).closest("form").submit();
				});
			},
			_Blur: function () {
				setTimeout(function () {
					this.DOMResults.setAttribute("class", "autocomplete");
				}.bind(this), 150);
			}
		}, ".form-search-autocomplete");
	}

	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	$.nette.ext("history", {
		success: function (e) {
			history.replaceState(null, "", e.history);
		}
	});

	$.nette.ext("cart", {
		success: function (e) {
			console.log(e);
			if (e.hasOwnProperty('cartCreated')) {
				$('#cart-create').modal('hide');
				$('#modal-add-to-cart').modal('show');
			}
		}
	})

	const typed = new Typed('#frm-searchForm-search', {
		stringsElement: '#typed-strings',
		typeSpeed: 50,
		backSpeed: 20,
		backDelay: 2000,
		startDelay: 0,
		attr: 'placeholder',
		smartBackspace: true,
		loop: true,
		contentType: 'html',
	});

	const typedMobile = new Typed('#frm-searchForm-search-mobile', {
		stringsElement: '#typed-strings',
		typeSpeed: 50,
		backSpeed: 20,
		backDelay: 2000,
		startDelay: 0,
		attr: 'placeholder',
		smartBackspace: true,
		loop: true,
		contentType: 'html',
	});

	if (window.innerWidth < 768) {
		$(".collapse-mobile").removeClass("show");
	}

	const starRating = new StarRating('.form-star-rating', {
		tooltip: 'Zvolte hodnocení',
		clearable: false,
		maxStars: 5,
	});

	$('a.link-reviews').on('click', function() {
		$('.nav-link-reviews').click();
		$('html, body').animate({
			scrollTop: $('#tab-container').offset().top - 100
		}, 'slow');
	});
});
